import React, { Component } from "react";
import { Navigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { FaFileInvoice } from "react-icons/fa";
import { FiSettings, FiRefreshCcw } from "react-icons/fi";
import {
  OverlayTrigger,
  Popover,
  Form,
  ListGroup,
  Navbar,
  Nav,
  Button,
} from "react-bootstrap";
import CartContext from "./CartContext";
import RefreshBearerToken from "./RefreshBearerToken";
import Settings from "./Settings";
import UserLoginNew from "./UserLoginNew";
import { LoadSpinner } from "./LoadSpinner";

export default class Navigation extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      loginRefreshCounter: 1,
      storeId: "",
      loadSpinnerOpen: false,
      ShowUserLoginNew: false,
    };
    this._isMounted = false;
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  GetMyStoreDetails = () => {
    fetch(process.env.REACT_APP_API + "Consumers/GetMyStoreDetails/")
      .then((r) => r.json())
      .then((data) => {
        if (!this._isMounted) return;
        if (!data?.id) return;

        this.context.setStoreId?.(data.id);
        if (this.state.storeId) return;

        this.setState({ storeId: data.id }, () => {
          this.context.GetStore?.();
          this.context.GetLoyaltyPointsConfig?.();
          this.context.GetStoreSettings?.();
          this.context.GetPosUserRoles?.();
          this.context.GetOrderStatusTypes?.();
          this.context.GetAllProducts?.();
          this.context.GetSellingPriceRules?.();
          this.context.getMainCategories?.();
          this.context.getSubCategories?.();
          this.context.getBrands?.();
          this.context.getShippingDetails?.();
          this.context.getTaxDetails?.();
          this.context.GetRestaturantTables?.();
          this.context.GetRestaurantTableOrdereStatus?.();
          this.context.GetWarehouses();
        });
      })
      .catch(() => {
        // Swal.fire("Offline?", "Please check your internet.", "error");
        Swal.fire(
          "Are you Offline?",
          "Option 1: Refresh this Browser if you have Internet Connectivity. <br/> Option 2: To run in Offline-mode, Follow the instruction given by Support Team!<br/>",
          "error"
        );
        this.context.LoadOffLineData();
      });
  };

  componentDidMount() {
    this._isMounted = true;
    if (!this.context?.storeId) this.GetMyStoreDetails();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  HideUserLoginNew = () => this.context.ShowUserLoginNew?.(false);

  SignOut = () => {
    this.context.clearUserData?.();
    this.context.ShowUserLoginNew?.(true);
  };

  render() {
    const ctx = this.context || {};
    const ud = ctx.userData || {};

    if (!ud) return null;
    if (ctx.hideMainNavBar) return null;

    return (
      <>
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}
        {ud.loginStatus === "active" && <RefreshBearerToken />}
        {ud.loginStatus != "active" &&
          ctx.showUserLoginNew &&
          ctx.isOfflineMode == false && (
            <UserLoginNew
              show={ctx.showUserLoginNew}
              onHide={this.HideUserLoginNew}
            />
          )}
        {this.context.prods.length > 0 ? (
          <MainNavigationBar SignOut={this.SignOut} />
        ) : (
          <> </>
        )}
      </>
    );
  }
}

class MainNavigationBar extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);

    this.state = {
      showOverlay: false,
      showSettings: false,
      selectedWarehouseId: "",
      expanded: false, // <- track navbar expanded/collapsed
      goHome: false,
    };
    const savedWh = localStorage.getItem("selectedWarehouseId");
    if (savedWh) {
      this.state.selectedWarehouseId = savedWh;
    }
  }

  SignOut = () => this.props.SignOut?.();
  OnLogin = () => this.context.ShowUserLoginNew?.(true);
  handleOnMouseEnter = () => this.setState({ showOverlay: true });
  handleOnMouseLeave = () => this.setState({ showOverlay: false });

  OnRefresh = () => {
    this.context.GetAllProducts?.();
    this.context.ClearSearchPos(true);
    Swal.fire({
      icon: "info",
      title: "Please wait...",
      timer: 3000,
      showConfirmButton: false,
    });
  };

  formatMoney = (n) => {
    const { storeSettings } = this.context || {};
    const locale = storeSettings?.defaultLocale || "en-IN";
    const currency = storeSettings?.defaultCurrency || "INR";
    return Number(n || 0).toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  handleWarehouseChange = (e) => {
    const whId = e.target.value;

    // Save in component state
    this.setState({ selectedWarehouseId: whId });

    // Store in localStorage
    localStorage.setItem("selectedWarehouseId", whId);

    // Refresh product list based on warehouse
    this.context.SetProducts(whId || "");

    // Redirect to home to reload items
    this.setState({ goHome: true });
  };

  // helper to close mobile menu (safe to call on desktop)
  closeMobileMenu = () => {
    if (window.innerWidth < 900) {
      this.setState({ expanded: false });
    }
  };
  componentDidMount() {
    const savedWh = this.state.selectedWarehouseId;

    if (savedWh) {
      // Apply warehouse to products
      this.context.SetProducts(savedWh);
    }
  }

  render() {
    const ctx = this.context || {};
    const { warehouses = [] } = ctx;
    const isDesktop = window.innerWidth >= 900;

    if (this.state.goHome) {
      this.setState({ goHome: false });
      return <Navigate to="/home" />;
    }

    return (
      <>
        {this.state.showSettings && (
          <Settings
            show={this.state.showSettings}
            onHide={() => this.setState({ showSettings: false })}
          />
        )}

        {isDesktop ? (
          // ---------- DESKTOP NAV ----------
          <Navbar bg="light" expand="lg" fixed="top" className="shadow-sm px-3">
            {/* Brand */}
            <Navbar.Brand href="https://elasticcart.com" target="_blank">
              <img
                src="https://ecprdstorage01.blob.core.windows.net/elasticcart/images/elasticcart.png"
                alt="ElasticCART"
                width="35"
              />
              <b className="ms-2">ElasticCART</b>
            </Navbar.Brand>

            {/* Center: POS / Tables */}
            <Nav className="mx-auto">
              <Nav.Link
                as={Link}
                to="/home"
                className={`fw-bold px-3 rounded-pill ${
                  ctx.modeOfSale === "PointOfSale" ? "bg-dark text-white" : ""
                }`}
                onClick={() => {
                  ctx.SetModeOfSale?.("PointOfSale");
                }}
              >
                POINT-OF-SALE (POS)
              </Nav.Link>
              {ctx.store?.businessTypeId === 3 && (
                <Nav.Link
                  as={Link}
                  to="/TableOrders"
                  className={`fw-bold px-3 ms-3 rounded-pill ${
                    ctx.modeOfSale === "TableOrder" ? "bg-dark text-white" : ""
                  }`}
                  onClick={() => ctx.SetBaseModeForTable?.()}
                >
                  Table Orders
                </Nav.Link>
              )}
            </Nav>

            <Nav>
              {this.context.isOfflineMode == true ? (
                <>
                  <h5 className="my-0 px-2 CornersRounded bg-dark text-warning text-center">
                    OFFLINE-MODE
                    <br />
                    <small className="text-white">
                      &nbsp;Unsync Orders = {this.context.offlineOrdersCount}{" "}
                      &nbsp;
                    </small>
                  </h5>
                </>
              ) : (
                <>
                  {this.context.offlineOrdersCount > 0 ? (
                    <>
                      <h5 className="my-2 py-1 bg-dark text-warning text-center">
                        &nbsp;Unsync Orders = {this.context.offlineOrdersCount}
                        &nbsp;
                        <br />
                        <Button onClick={(e) => this.context.SyncOrdersStart()}>
                          Sync Now
                        </Button>
                      </h5>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </Nav>
            {/* Right controls */}
            <div className="d-flex align-items-center gap-2">
              {/* ... same as before ... */}
              {warehouses.length > 0 && (
                <Form.Select
                  size="sm"
                  value={this.state.selectedWarehouseId}
                  onChange={this.handleWarehouseChange}
                  style={{ width: 180 }}
                >
                  <option value="">All Warehouses</option>
                  {warehouses.map((wh) => (
                    <option key={wh.id} value={wh.id}>
                      {wh.name}
                    </option>
                  ))}
                </Form.Select>
              )}

              <Button
                variant="light"
                size="sm"
                onClick={this.OnRefresh}
                disabled={ctx.isOfflineMode}
              >
                <FiRefreshCcw />
              </Button>
              <Button
                variant="light"
                size="sm"
                onClick={() => this.setState({ showSettings: true })}
              >
                <FiSettings />
              </Button>

              <Nav.Link
                as={Link}
                to="/UserOrders"
                className="border rounded px-2 py-1 d-flex align-items-center text-success"
              >
                <FaFileInvoice className="me-1" size={20} />
                <span style={{ fontSize: "22px" }}>
                  {this.formatMoney(ctx.lastBillAmount || 0)}
                </span>
              </Nav.Link>

              <Nav.Link
                as={Link}
                className=" mx-0"
                to=""
                hidden={ctx.userData?.hideSignupLink}
                onClick={this.OnLogin}
              >
                <span className="visually-hidden">Login</span>
                <svg width="0" height="0" />
              </Nav.Link>

              <OverlayTrigger
                show={this.state.showOverlay}
                placement="bottom"
                rootClose={false}
                overlay={
                  <Popover
                    id="user-popover"
                    onMouseEnter={this.handleOnMouseEnter}
                    onMouseLeave={this.handleOnMouseLeave}
                  >
                    <Popover.Header as="h3"></Popover.Header>
                    <Popover.Body>
                      <UserMenu SignOut={this.SignOut} />
                    </Popover.Body>
                  </Popover>
                }
              >
                <Button
                  className="rounded-circle mx-3 bg-light border-0"
                  variant=""
                  hidden={!ctx.userData?.hideSignupLink}
                  onMouseEnter={this.handleOnMouseEnter}
                  onMouseLeave={this.handleOnMouseLeave}
                  aria-label="User menu"
                >
                  <span
                    className="bi bi-person"
                    style={{ fontSize: 22, color: "navy" }}
                  />
                </Button>
              </OverlayTrigger>
            </div>
          </Navbar>
        ) : (
          // ---------- MOBILE NAV ----------
          // Controlled Navbar: expanded and onToggle manage collapse
          <Navbar
            bg="dark"
            variant="dark"
            expand="sm"
            fixed="top"
            className="px-2"
            expanded={this.state.expanded}
            onToggle={(isOpen) => this.setState({ expanded: isOpen })}
          >
            <Navbar.Brand href="https://elasticcart.com" target="_blank">
              <img
                src="https://ecprdstorage01.blob.core.windows.net/elasticcart/images/elasticcart.png"
                alt="ElasticCART"
                width="28"
                className="rounded-circle"
              />
              <b className="ms-1">ElasticCART</b>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="mobile-navbar" />

            <Navbar.Collapse
              id="mobile-navbar"
              className="justify-content-between"
            >
              <Nav className="me-auto">
                <Nav.Link
                  as={Link}
                  to="/home"
                  className={
                    ctx.modeOfSale === "PointOfSale"
                      ? "bg-light text-dark px-2 rounded"
                      : ""
                  }
                  onClick={() => {
                    ctx.SetModeOfSale?.("PointOfSale");
                    this.closeMobileMenu(); // <- close menu after click
                  }}
                >
                  POS
                </Nav.Link>

                {ctx.store?.businessTypeId === 3 && (
                  <Nav.Link
                    as={Link}
                    to="/TableOrders"
                    className={
                      ctx.modeOfSale === "TableOrder"
                        ? "bg-light text-dark px-2 rounded"
                        : ""
                    }
                    onClick={() => {
                      this.context.SetBaseModeForTable?.();
                      this.closeMobileMenu(); // <- close menu after click
                    }}
                  >
                    TABLE
                  </Nav.Link>
                )}
              </Nav>

              <Button
                variant="outline-light"
                size="sm"
                onClick={() => {
                  this.context.ShowUserLoginNew?.(true);
                  this.closeMobileMenu();
                }}
              >
                <span className="bi bi-person" />
              </Button>
            </Navbar.Collapse>
          </Navbar>
        )}
      </>
    );
  }
}

class UserMenu extends Component {
  static contextType = CartContext;
  render() {
    const name = this.context?.userData?.firstName || "User";
    return (
      <>
        <div className="text-center">
          <h5>Hello {name}</h5>
        </div>
        <ListGroup variant="flush">
          <ListGroup.Item
            as={Link}
            action
            to="/LicensePage"
            disabled={this.context.isOfflineMode}
          >
            Apply License
          </ListGroup.Item>
          <ListGroup.Item
            as={Link}
            action
            to="/home"
            onClick={() => {
              this.context.clearUserData?.();
              this.props.SignOut?.();
            }}
          >
            Sign Out
          </ListGroup.Item>
        </ListGroup>
      </>
    );
  }
}
